module.exports = __webpack_public_path__ + "static/media/19ESCAP31.9c0abd51.jpg";